import * as React from "react"
import { Skeleton } from "@mui/material";


import {useToast} from "@hooks";
import { WEBBACK_V2_API } from "@constants";
import { TitleWithPopover, AppTableSeeker } from "@components";
import { useLostBuyBoxOverviewTableData } from "../@hooks";
import { retailerColumn, skuColumn, daysDeliveryColumn, percentageColumn, reasonsColumn, averagePricesColumn, numSellersColumn, topSellersColumn } from "./columns";


export default function LostBuyBoxOverviewTable() {

	const { overviewTableData, overviewTableReasonsInfo, isLoadingOverviewTable } = useLostBuyBoxOverviewTableData()

	const { showToast } = useToast()

	if (isLoadingOverviewTable) return <Skeleton variant="rectangular" height={500} />
	if (!overviewTableData?.length) return <></>

	return <AppTableSeeker
		data={overviewTableData}
		title={<TitleWithPopover title="Lost Buy Box" />}
		columns={[
			...retailerColumn(),
			...skuColumn(),
			percentageColumn('percentageLBB', 'LBB %'),
			reasonsColumn(overviewTableReasonsInfo),
			averagePricesColumn(),
			numSellersColumn(),
			topSellersColumn(),
			...daysDeliveryColumn(),
		]}
		options={{
			onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/marketplaces/lose-buy-box-overview/overview-table-excel`),
		}}
	/>
}